import React from 'react'
import {AuthContext} from "@containers/auth/context/AuthContextProvider";

export const useAuthContext = () => React.useContext(AuthContext)